module.exports = __webpack_public_path__ + "static/media/terms_and_condition.26108b12.svg";